import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptor } from './interceptors/httpconfig.interceptor';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { LoaderComponent } from './loader/loader.component';
import { CalendarYearComponent } from './calendar-year/calendar-year.component';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { CaseModesSwitchesComponent } from './case-modes-switches/case-modes-switches.component';
import { CaseServiceMaterialsComponent } from './case-service-materials/case-service-materials.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { FormFieldErrorDirective } from './directive/form-field-error.directive';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { TableModule } from 'primeng/table';
import { LazyImgDirective } from './directive/lazy-img.directive';
import { ClearMultiSelectFilterOnOpenDirective, ClearDropdownFilterOnOpenDirective } from './directive/clear-filter-on-open.directive';
import { CalendarNoShowOnFocusDirective } from './directive/calendar-defaults.directive';
import { StickyHscrollDirective } from './directive/sticky-hscroll.directive';
import { TableCellComponent } from './table-cell/table-cell.component';
import { DynamicFieldsComponent } from './dynamic-fields/dynamic-fields.component';
import { InputTextarea } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';


@NgModule({
  declarations: [
    SidebarComponent,
    TopbarComponent,
    LoaderComponent,
    CalendarYearComponent,
    FilterPanelComponent,
    CaseModesSwitchesComponent,
    CaseServiceMaterialsComponent,
    DynamicFieldsComponent,

    FormFieldErrorDirective,
    LazyImgDirective,
    ClearMultiSelectFilterOnOpenDirective,
    ClearDropdownFilterOnOpenDirective,
    CalendarNoShowOnFocusDirective,
    StickyHscrollDirective,
    TableCellComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PanelMenuModule,
    InputTextModule,
    TooltipModule,
    ButtonModule,
    OverlayPanelModule,
    FormsModule,
    BrowserAnimationsModule,
    BadgeModule,
    MenuModule,
    DialogModule,
    PasswordModule,
    BrowserModule,
    TableModule,
    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    InputNumberModule,
    InputSwitchModule,
    InputTextarea,
    CheckboxModule,
    ListboxModule
  ],
  exports: [
    SidebarComponent,
    TopbarComponent,
    LoaderComponent,
    CalendarYearComponent,
    FilterPanelComponent,
    CaseModesSwitchesComponent,
    CaseServiceMaterialsComponent,
    DynamicFieldsComponent,
    AutoCompleteModule,
    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    InputNumberModule,

    FormFieldErrorDirective,
    LazyImgDirective,
    ClearMultiSelectFilterOnOpenDirective,
    ClearDropdownFilterOnOpenDirective,
    CalendarNoShowOnFocusDirective,
    StickyHscrollDirective,
    TableCellComponent
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }]
})
export class CoreModule { }
